var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1276,
    cy: 15,
    rx: 15.1276,
    ry: 15,
    fill: "#FF6B62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.691 19.321L16.8388 16.864H13.3121L12.473 19.321H10.6899L14.1249 10H16.0391L19.474 19.321H17.691ZM15.5933 13.042C15.5583 12.9207 15.5059 12.756 15.436 12.548C15.366 12.34 15.2961 12.1277 15.2262 11.911C15.165 11.6857 15.1169 11.4993 15.082 11.352C15.0383 11.5253 14.9815 11.7247 14.9115 11.95C14.8504 12.1753 14.7892 12.3877 14.728 12.587C14.6756 12.7863 14.6319 12.938 14.5969 13.042L13.7709 15.434H16.4062L15.5933 13.042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqA);
export default __webpack_public_path__ + "static/media/faq_a.a385e3494b8267793529c0b79b2b978b.svg";
export { ForwardRef as ReactComponent };